import React, { useState } from 'react';
import { ref, push } from 'firebase/database';
import { database } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import './Forms.css';

const RendezVous = () => {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    nom: '',
    telephone: '',
    email: currentUser?.email || '',
    adresseDepart: '',
    adresseArrivee: '',
    date: '',
    typeService: 'maison',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const rendezvousRef = ref(database, 'rendezvous/' + currentUser.uid);
    push(rendezvousRef, {
      ...formData,
      statut: 'en attente',
      dateCreation: new Date().toISOString(),
      userId: currentUser.uid
    });
    
    setSubmitted(true);
    setFormData({
      ...formData,
      nom: '',
      telephone: '',
      adresseDepart: '',
      adresseArrivee: '',
      date: '',
      message: ''
    });
    
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="form-container">
      <h2>Prendre rendez-vous</h2>
      <form onSubmit={handleSubmit} className="dashboard-form">
        <div className="form-row">
          <div className="form-group">
            <label>Nom complet *</label>
            <input
              type="text"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Téléphone *</label>
            <input
              type="tel"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Email *</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            readOnly
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Adresse de départ *</label>
            <input
              type="text"
              name="adresseDepart"
              value={formData.adresseDepart}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Adresse d'arrivée *</label>
            <input
              type="text"
              name="adresseArrivee"
              value={formData.adresseArrivee}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Date du déménagement *</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
              min={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className="form-group">
            <label>Type de service *</label>
            <select
              name="typeService"
              value={formData.typeService}
              onChange={handleChange}
              required
            >
              <option value="maison">Déménagement maison</option>
              <option value="bureau">Déménagement bureau</option>
              <option value="meubles">Transport de meubles</option>
              <option value="longue-distance">Transport longue distance</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Message (optionnel)</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="4"
          ></textarea>
        </div>

        <button type="submit" className="btn btn-primary">Prendre rendez-vous</button>
        {submitted && <p className="success-message">Rendez-vous envoyé avec succès !</p>}
      </form>
    </div>
  );
};

export default RendezVous;